const pseudoComponents_WCS = [
  { name: "PC01", Tb: 40, MW: 85, Tc: 475, Pc: 34.5, omega: 0.2, SG: 0.675 },
  { name: "PC02", Tb: 60, MW: 95, Tc: 490, Pc: 33.0, omega: 0.22, SG: 0.685 },
  { name: "PC03", Tb: 80, MW: 105, Tc: 505, Pc: 31.5, omega: 0.23, SG: 0.695 },
  { name: "PC04", Tb: 100, MW: 115, Tc: 520, Pc: 30.0, omega: 0.24, SG: 0.705 },
  { name: "PC05", Tb: 120, MW: 125, Tc: 535, Pc: 28.5, omega: 0.25, SG: 0.715 },
  { name: "PC06", Tb: 140, MW: 135, Tc: 550, Pc: 27.0, omega: 0.26, SG: 0.725 },
  { name: "PC07", Tb: 160, MW: 145, Tc: 565, Pc: 26.0, omega: 0.27, SG: 0.735 },
  { name: "PC08", Tb: 180, MW: 155, Tc: 580, Pc: 25.0, omega: 0.28, SG: 0.745 },
  { name: "PC09", Tb: 200, MW: 165, Tc: 595, Pc: 24.0, omega: 0.29, SG: 0.755 },
  { name: "PC10", Tb: 220, MW: 175, Tc: 610, Pc: 23.0, omega: 0.3, SG: 0.765 },
  { name: "PC11", Tb: 240, MW: 190, Tc: 625, Pc: 22.0, omega: 0.31, SG: 0.775 },
  { name: "PC12", Tb: 260, MW: 205, Tc: 640, Pc: 21.0, omega: 0.32, SG: 0.785 },
  { name: "PC13", Tb: 280, MW: 220, Tc: 655, Pc: 20.0, omega: 0.33, SG: 0.795 },
  { name: "PC14", Tb: 300, MW: 235, Tc: 670, Pc: 19.0, omega: 0.34, SG: 0.805 },
  { name: "PC15", Tb: 320, MW: 250, Tc: 685, Pc: 18.0, omega: 0.35, SG: 0.815 },
  { name: "PC16", Tb: 340, MW: 265, Tc: 700, Pc: 17.0, omega: 0.36, SG: 0.825 },
  { name: "PC17", Tb: 360, MW: 280, Tc: 715, Pc: 16.0, omega: 0.37, SG: 0.835 },
  { name: "PC18", Tb: 380, MW: 295, Tc: 730, Pc: 15.0, omega: 0.38, SG: 0.845 },
  { name: "PC19", Tb: 400, MW: 310, Tc: 745, Pc: 14.5, omega: 0.39, SG: 0.855 },
  { name: "PC20", Tb: 420, MW: 330, Tc: 760, Pc: 14.0, omega: 0.4, SG: 0.865 },
  { name: "PC21", Tb: 440, MW: 350, Tc: 775, Pc: 13.5, omega: 0.41, SG: 0.875 },
  { name: "PC22", Tb: 460, MW: 370, Tc: 790, Pc: 13.0, omega: 0.42, SG: 0.885 },
  { name: "PC23", Tb: 480, MW: 390, Tc: 805, Pc: 12.5, omega: 0.43, SG: 0.895 },
  { name: "PC24", Tb: 500, MW: 410, Tc: 820, Pc: 12.0, omega: 0.44, SG: 0.905 },
  { name: "PC25", Tb: 520, MW: 430, Tc: 835, Pc: 14.0, omega: 0.45, SG: 0.915 }, // Tc/Pc ≈ 59.6
  { name: "PC26", Tb: 540, MW: 450, Tc: 850, Pc: 14.5, omega: 0.45, SG: 0.925 }, // Tc/Pc ≈ 58.6
  { name: "PC27", Tb: 560, MW: 470, Tc: 865, Pc: 15.0, omega: 0.45, SG: 0.935 }, // Tc/Pc ≈ 57.7
  { name: "PC28", Tb: 580, MW: 490, Tc: 880, Pc: 15.5, omega: 0.45, SG: 0.945 }, // Tc/Pc ≈ 56.8
  { name: "PC29", Tb: 600, MW: 510, Tc: 895, Pc: 16.0, omega: 0.45, SG: 0.955 }, // Tc/Pc ≈ 55.9
  { name: "PC30", Tb: 620, MW: 530, Tc: 910, Pc: 16.5, omega: 0.45, SG: 0.965 }, // Tc/Pc ≈ 55.2
];

export default pseudoComponents_WCS;
